export default {
  buttons: {
    change_plan: 'Plan wijzigen',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt',
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt',
  },
};
